module.exports = __webpack_public_path__ + "img/file.83c01a90.svg";